import { HostPage } from "./components/HostPage";

export const onInitService = ({ createExtension, registerAction }) => {
  // Register all the embed pages routes
  const pages = createExtension.sync("$ONE_EMBED_PAGE").map(($) => $[0]);
  pages.forEach(({ target, hook, ...route }) =>
    registerAction({
      target: "$ONE_LAYOUT_ROUTE",
      handler: {
        ...route,
        element: <HostPage {...{ target, hook }} />
      }
    })
  );
};
